
import React, { Suspense, lazy } from 'react';
import FAQAccordion from '@/components/tours/FAQAccordion';
import BookingCTA from '@/components/tours/BookingCTA';

interface TourContentProps {
  faqs: Array<{question: string; answer: string}>;
}

// Lazy-load the TourExpectations component which isn't needed for initial render
const TourExpectations = lazy(() => import('@/components/tours/TourExpectations'));

const TourContent: React.FC<TourContentProps> = ({ faqs }) => {
  return (
    <>
      {/* Lazy-load TourExpectations component */}
      <Suspense fallback={<div className="py-16 bg-white min-h-[300px] flex items-center justify-center" aria-live="polite">Loading tour details...</div>}>
        <TourExpectations />
      </Suspense>
      
      <section className="py-16 bg-[#F5EDE0]" aria-labelledby="faq-heading">
        <div className="container mx-auto px-4 max-w-3xl">
          <h2 id="faq-heading" className="text-2xl md:text-3xl font-playfair font-bold mb-8 text-center">Frequently Asked Questions</h2>
          <FAQAccordion faqs={faqs} />
        </div>
      </section>
      
      <section className="py-16 bg-[#C46829]" aria-labelledby="booking-heading">
        <h2 id="booking-heading" className="sr-only">Book your tour</h2>
        <BookingCTA />
      </section>
    </>
  );
};

export default TourContent;
